var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-step-setup" },
    [
      _c("CompassAlert", {
        staticClass: "mb-4",
        attrs: {
          description: _vm.$t.__("settings.import.ImportSetupStep.alert"),
          "show-close": false
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inner-stepper" },
        [
          _c(
            "div",
            { staticClass: "inner-step-choice" },
            _vm._l(_vm.stepper, function(step) {
              return _c(
                "div",
                {
                  key: step.id,
                  staticClass: "inner-step-item",
                  class: {
                    active: step.id === _vm.getCurrentSubStep.id,
                    valid: step.isValid
                  },
                  on: {
                    click: function($event) {
                      return _vm.onClickInnerStepItem(step)
                    }
                  }
                },
                [
                  step.isValid && step.id !== _vm.getCurrentSubStep.id
                    ? _c(
                        "span",
                        { staticClass: "check" },
                        [
                          _c("CompassIcon", {
                            attrs: { type: "success", icon: "check" }
                          })
                        ],
                        1
                      )
                    : _c("span", { staticClass: "number" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(step.id) +
                            "\n                "
                        )
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inner-step-item-description" }, [
                    _c("h4", { staticClass: "title typographies-heading-h4" }, [
                      _vm._v(_vm._s(step.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "subtitle typographies-paragraph-small-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(step.subTitle) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "Transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              _c(_vm.innerStepComponent, {
                tag: "component",
                staticClass: "inner-step-content"
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }